import { useEffect } from 'react';

import { ChakraProvider } from '@chakra-ui/react';
import ko from 'date-fns/locale/ko';
import { registerLocale } from 'react-datepicker';
import { Provider } from 'react-redux';
import { useRoutes } from 'react-router-dom';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import { AxiosInterceptor } from '@/apis/AxiosInterceptor';
import Toast from '@/components/Tools/Toast';
import QueryProvider from '@/context/react-query/QueryProvider';
import routeInfo from '@/layouts/config/router';
import theme from '@/theme';
import { Fonts } from '@/theme/foundations/fonts';
import { setupViewportHeightVar } from '@/utils/viewport';

import store from '../context/redux/store';

import 'react-datepicker/dist/react-datepicker.css';

registerLocale('ko', ko);

export const persistor = persistStore(store);

const App = () => {
  useEffect(() => {
    return setupViewportHeightVar();
  }, []);

  const RouteElement = useRoutes(routeInfo);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ChakraProvider theme={theme}>
          <Fonts />
          <Toast />
          <QueryProvider>
            <AxiosInterceptor>{RouteElement}</AxiosInterceptor>
          </QueryProvider>
        </ChakraProvider>
      </PersistGate>
    </Provider>
  );
};
export default App;
